export default {
  'resetpassword.maintext':
    'برای تنظیم مجدد رمز عبور لطفا رمز عبور جدید خود را در هر دو فیلد وارد نمایید',
  'resetpassword.retypepassword': 'تایپ مجدد رمز عبور',
};
